module.exports = __webpack_public_path__ + "assets/task-list.e492bd76.svg";